import type { ButtonState } from "@edco/apollo";

type ButtonStateOptions = {
  resetDuration?: number;
  ignoreSuccess?: boolean;
};

export function useButtonState ( options?: ButtonStateOptions ) {
  const buttonState = ref<ButtonState>();

  watch( buttonState, ( val ) => {
    const watchedStates: ButtonState[] = options?.ignoreSuccess
      ? ["failure"]
      : ["success", "failure"];

    if ( watchedStates.includes( val! ) ) {
      setTimeout( () => {
        buttonState.value = null;
      }, options?.resetDuration ?? 2000 );
    }
  } );

  return buttonState;
}
